import { useQuery } from 'react-query';
import { putTestData } from 'services/apiCalls';

export default function useGetKPIs(
  class_list: string[] = [],
  start_year: string,
  start_month: string,
  end_year: string = '',
  end_month: string = '',
  store_list: string[] = [],
  dept_list: string[] = [],
  sub_category_list: string[] = []
) {
  const path = `sales_and_inventory_performance/cards`;
  const { data, isLoading } = useQuery(
    [
      'cards_sales_overview',
      class_list,
      start_year,
      start_month,
      end_year,
      end_month,
      store_list,
      dept_list,
      sub_category_list,
    ],
    () =>
      putTestData(path, {
        class_list,
        start_year,
        start_month,
        end_year,
        end_month,
        store_list,
        dept_list,
        sub_category_list,
      }),
    {
      enabled:
        !!start_year &&
        !!start_month &&
        !!class_list.length &&
        Array.isArray(store_list) &&
        !!store_list.length,
    }
  );

  return {
    data: (data && data[0] && data[0]) ?? null,
    isLoading,
  };
}
